import React from 'react';
import './Modal.css';

const CardRevealModal = ({ card, title, onClose }) => {
  if (!card) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content-reveal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <img
          src={card.card_images[0].image_url}
          alt={card.name}
          className="reveal-card-img"
        />
        <p><strong>{card.name}</strong></p>
        <p>{card.desc}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default CardRevealModal;
